import axios from "axios";
import {
  setUser,
  setRecoverPassword,
  setCredentials,
  setWallet,
  resetUser,
  setChangePassword,
} from "../reducers/user";
import { encryptText, getToken } from "../../shared/utils";

const URL = process.env.REACT_APP_CORE;

export const getUserPortal = (id) => async (dispatch) => {
  dispatch(
    setUser({
      data: null,
      isLoading: true,
      error: null,
    })
  );

  let url = `${URL}usuarios/${id}`;

  const configDocIden = {
    method: "GET",
    maxBodyLength: Infinity,
    url,
  };

  axios(configDocIden)
    .then((response) => {
      localStorage.setItem("userId", response?.data?.usuarioid);
      dispatch(getCredentialsPortal(response?.data?.usuarioid));
      dispatch(
        setUser({
          data: response?.data,
          isLoading: false,
          error: null,
        })
      );
    })
    .catch((error) => {
      dispatch(
        setUser({
          data: null,
          isLoading: false,
          error: error?.response?.data?.error,
        })
      );
    });
};

export const login = (username, password, otp) => async (dispatch) => {
  dispatch(setUser({ data: null, isLoading: true, error: null }));

  const tokenObtained = await getToken();

  if (!tokenObtained) {
    dispatch(
      setUser({
        data: null,
        isLoading: false,
        error: "Error al obtener el token de autenticación",
      })
    );
    return;
  }

  const encryptedUsername = encryptText(username);
  const encryptedPassword = encryptText(password);
  const encryptedOtp = encryptText(otp);

  // R23: la clave "token" nunca se escribe; la unica que se setea es
  // "tokenContraPago" (shared/utils.js getToken). Antes esto mandaba
  // Authorization: Bearer null y "funcionaba" porque nadie validaba.
  const token = localStorage.getItem("tokenContraPago");

  const config = {
    method: "POST",
    url: `${URL}login`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      type: "GFLogin",
      user_name: encryptedUsername,
      password: encryptedPassword,
      otp_code: encryptedOtp,
    },
  };

  axios(config)
    .then(function (response) {
      if (response?.data?.error || response?.data?.message?.includes("@")) {
        dispatch(
          setUser({
            data: null,
            isLoading: false,
            error: response?.data?.error || response?.data?.message,
          })
        );
        return;
      }

      dispatch(getUserPortal(response?.data?.user));
    })
    .catch(function (error) {
      return;
    });
};

export const logout = (username, password) => async (dispatch) => {
  // R23: la clave "token" nunca se escribe; la unica que se setea es
  // "tokenContraPago" (shared/utils.js getToken). Antes esto mandaba
  // Authorization: Bearer null y "funcionaba" porque nadie validaba.
  const token = localStorage.getItem("tokenContraPago");
  const config = {
    method: "GET",
    url: `${URL}login?type=GFLogout&user_name=${username}&password=${password}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  // dispatch(setUser({ data: null, isLoading: true, error: null }));

  axios(config)
    .then(function (response) {
      if (response?.data?.error) {
        dispatch(
          setUser({
            data: null,
            isLoading: false,
            error: response?.data?.error,
          })
        );
        return;
      }

      dispatch(resetUser());
      // El logout borraba la clave "token", que nunca existio: la sesion
      // seguia viva en el browser. La real es "tokenContraPago".
      localStorage.removeItem("tokenContraPago");
      localStorage.removeItem("userId");
      window.location.href = "/";
    })
    .catch((error) => {
      dispatch(
        setUser({
          data: null,
          isLoading: false,
          error: error?.response?.data?.error,
        })
      );
    });
};

export const recoverPassword = (email) => async (dispatch) => {
  dispatch(
    setRecoverPassword({
      isLoading: true,
      error: null,
      success: null,
    })
  );

  // R23: la clave "token" nunca se escribe; la unica que se setea es
  // "tokenContraPago" (shared/utils.js getToken). Antes esto mandaba
  // Authorization: Bearer null y "funcionaba" porque nadie validaba.
  const token = localStorage.getItem("tokenContraPago");
  const config = {
    method: "POST",
    url: `${URL}recoverypassword`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      mail: email,
    },
  };

  axios(config)
    .then(function (response) {
      dispatch(
        setRecoverPassword({
          isLoading: false,
          error: null,
          success: response?.data?.mensaje || "Password recovered successfully",
        })
      );
    })
    .catch(function (error) {
      dispatch(
        setRecoverPassword({
          isLoading: false,
          error: error?.response?.data?.error,
          success: null,
        })
      );
    });
};

export const getCredentialsPortal = (id) => async (dispatch) => {
  dispatch(
    setCredentials({
      data: null,
      isLoading: true,
      error: null,
    })
  );

  const configCredentials = {
    method: "GET",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_API_PORTAL}clientes?userid=${id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("tokenContraPago")}`,
    },
  };

  axios(configCredentials)
    .then((response) => {
      dispatch(getWalletPortal(response?.data?.data?.[0]?.id));
      dispatch(
        setCredentials({
          data: response?.data?.data?.[0] || null,
          isLoading: false,
          error: null,
        })
      );
    })
    .catch((error) => {
      dispatch(
        setCredentials({
          data: null,
          isLoading: false,
          error: error?.response?.data,
        })
      );
    });
};

export const getWalletPortal = (idCredential) => async (dispatch) => {
  dispatch(
    setWallet({
      data: null,
      isLoading: true,
      error: null,
    })
  );

  const configDocIden = {
    method: "GET",
    maxBodyLength: Infinity,
    url: `${process.env.REACT_APP_API_PORTAL}wallet?idclient=${idCredential}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("tokenContraPago")}`,
    },
  };

  axios(configDocIden)
    .then((response) => {
      dispatch(
        setWallet({
          data: response?.data?.data?.[0] || null,
          isLoading: false,
          error: null,
        })
      );
    })
    .catch((error) => {
      dispatch(
        setWallet({
          data: null,
          isLoading: false,
          error: error?.response?.data,
        })
      );
    });
};

export const changePassword = (newPassword, userId) => async (dispatch) => {
  dispatch(
    setChangePassword({
      message: null,
      isLoading: true,
      error: null,
    })
  );

  // R23: la clave "token" nunca se escribe; la unica que se setea es
  // "tokenContraPago" (shared/utils.js getToken). Antes esto mandaba
  // Authorization: Bearer null y "funcionaba" porque nadie validaba.
  const token = localStorage.getItem("tokenContraPago");
  const config = {
    method: "PUT",
    url: `${URL}usuarios/${userId}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      clave: newPassword,
    },
  };

  axios(config)
    .then((response) => {
      dispatch(
        setChangePassword({
          message: response?.data?.message
            ? "Password changed successfully"
            : "",
          isLoading: false,
          error: null,
        })
      );
    })
    .catch((error) => {
      dispatch(
        setChangePassword({
          message: "Error changing password",
          isLoading: false,
          error: true,
        })
      );
    });
};
